(function () {
    'use strict';
    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('valuation-wrapper', {
                url: '/:langcode/{path:property-value|emlak-degeri|valor-de-la-propiedad|valor-da-propriedade}/:address?name?rent',
                templateUrl: 'app/valuation-wrapper/valuation-wrapper.html',
                controller: 'ValuationWrapperController',
                params: {
                    address: {
                        value: null,
                        squash: true,
                        type: 'any',
                        raw: true
                    },
                    name: {
                        value: null
                    },
                    path: ['$translate', function ($translate) {
                        return $translate.instant("valuation-wrapper");
                    }],
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'valuationWrapper');
                    }],

                    LangProtect: ['routeHelpers', function(routeHelpers) {
                        return routeHelpers.langProtect();
                    }],
                    title: ['$translate', function ($translate) {
                        return $translate('c_val_wrap_title').then(function (res) {
                            return res;
                        });
                    }],
                    description: ['$translate', function ($translate) {
                        return $translate('c_val_wrap_desc').then(function (res) {
                            return res;
                        });
                    }],


                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('valuation_wrap');
                        return $translate.refresh();
                    }]
                },

                metaTags: {
                    title: '{{title}}',
                    robots: [
                        '$transition$',
                        function ($transition$) {
                            if ($transition$.params().address)
                                return 'noindex, nofollow';
                            else
                                return 'index, follow';
                        }
                    ],
                    description: '{{description}}',
                    properties: {
                        'og:image': 'http://www.endeksa.com/share3.jpg',
                        'og:image:secure_url': 'https://www.endeksa.com/share3.jpg',
                        'og:type': 'website'
                    }
                }
            });
    }]);
    angular.module("app.wrap", ["app.common"]);
})();
